import React, {Component} from 'react';
import {QuestionerItem} from "./questionerItem";
import {QuestionerNavigation} from "./navigation/navigation";
import {QuestionerList} from "app/model/questioner";
import {map} from 'lodash'
import {isMobile} from "app/lib/dimesions";

export class Questioner extends Component {
    constructor() {
        super();
        this.questioner = QuestionerList.create(window.questioner.questions);
        this.state = {
            current: null,
        };

        this.handleAnswerBtnClick = this.handleAnswerBtnClick.bind(this);
        this.handleNavigation = this.handleNavigation.bind(this);
    }

    handleAnswerBtnClick(question) {
        if (isMobile()) {
            return;
        }

        const current = this.state.current === question ? null : question;

        this.setState({
            current,
        })
    }

    handleNavigation(question) {
        this.setState({
            current: question
        });
    }

    /** @private */
    _renderQuestions(questioner) {
        const {questions} = questioner;

        return map(questions, (question) => {
            const {current} = this.state;
            const isActive = isMobile() ? true : question === current;
            const hide = isMobile() ? !(question === current) : false;

            return (
                <QuestionerItem
                    key={question.title}
                    question={question}
                    isActive={isActive}
                    hide={hide}
                    onClickAnswerBtn={this.handleAnswerBtnClick}/>
            )
        });
    }

    /** @private */
    _renderNavigation(questioner) {
        if (!isMobile()) {
            return;
        }

        return (
            <QuestionerNavigation
                questioner={questioner}
                onNavigation={this.handleNavigation}/>
        )
    }

    render() {
        const questions = this._renderQuestions(this.questioner);
        const navigation = this._renderNavigation(this.questioner);

        return (
            <div className='questioner-wrapper'>
                {navigation}
                <div className="row">
                    {questions}
                </div>
            </div>
        )
    }
}
